export default __webpack_public_path__ + "static/media/Muistilista HSL OpenMaaS -rajapintasopimusta tekeville_14.1.2021.f5992379.pdf";